module.exports = __webpack_public_path__ + "img/star_red.1c4fe3c0.png";